// generate 404 page component
function page404() {
	return (
		<div className="flex flex-col items-center justify-center h-screen">
			<h1 className="text-4xl font-bold text-black dark:text-white ">
				404
			</h1>
			<p className="text-2xl text-black dark:text-white">
				Page not found
			</p>
		</div>
	);
}

export default page404;
